import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@material-ui/core';
import './Header.css';

// Firebase
import { firebaseSdk } from '../Firebase/Init';

export default function Header(props) {
    const history = useHistory();
    
    const handleSignout = () => {
        firebaseSdk.auth().signOut().then(function () {
            // Sign-out successful.
            history.push('/Login');
            localStorage.removeItem('cart');
            localStorage.removeItem('user');
        }).catch(function (error) {
            // An error happened.
            alert('Error upon signing out.');
        });
    }

    return (
        <div className="Header-body">{props.title} <Button className="float-right" variant="contained" color="secondary" onClick={handleSignout}>Sign Out</Button></div>
    );
}